import layerManager from '../layer.manager';
import * as layerNames from '../layerName';
import { DynamicSpecification } from './specification/specification';
import { vrConfrimParam } from '@/services/vrShow/vr.common';

import {
  PopSpecification,
  OrderPoupSpecification,
  ThreeCarSpecification,
  PromotionSpecification,
  SahuanActivitySpecification,
  PromotionActivitySpecification,
  DealerActivitySpecification,
  DealerActivityIdSpecification,
  VideoListSpecification,
  RedPacketSpecification,
  RedPacketSharedTipSpecification,
  RedPacketSharedSpecification,
  VRShowTapeGuideSpecification,
  WelcomeAdSpecification
} from './specification/homePoupSpecification';

class HomePoup {
  constructor (queryParams, specification) {
    this.queryParams = queryParams;
    this.specification = specification;
  }
  /**
   * 是否可以执行
   */
  canExecute () {
    return this.specification.isSatisfiedBy(this.queryParams);
  }
  /**
   * 执行
   * @returns
   */
  execute () {
    if (this.canExecute()) {
      this.action();
      return true;
    }
    return false;
  }
  /**
   * 执行的操作
   * @returns
   */
  action () {
    return false;
  }
}
/**
 *  首屏订单弹层
 */
export class HomeOrderPoup extends HomePoup {
  constructor (queryParams) {
    super(queryParams, new PopSpecification());
    this.specification = this.specification.or(new OrderPoupSpecification());
  }
  action () {
    layerManager.price(this.queryParams.seriesId || 0, 0, 'bottomprice', 1);
  }
}

/**
 * 首屏促销文章弹层
 */
export class HomePromotionPoup extends HomePoup {
  constructor (queryParams) {
    super(queryParams, new PromotionSpecification());
  }
  action () {
    layerManager.loadPromotionInfo(this.queryParams.actId, true, { isAutoOpen: true });
  }
}
/**
 * 首屏促销活动弹层
 */
export class HomePromotionActivityPoup extends HomePoup {
  constructor (queryParams) {
    super(queryParams, new PromotionActivitySpecification()
      .or(new SahuanActivitySpecification()));
  }
  action () {
    const activityId = this.queryParams.activityId || this.queryParams.actId;
    layerManager.loadActivityInfo(activityId, { isAutoOpen: true });
  }
}
/**
 * 首屏互动游戏弹层
 */
export class HomeGamePoup extends HomePoup {
  constructor (queryParams, gameList, salesId) {
    super(queryParams, new DealerActivitySpecification().or(new DealerActivityIdSpecification()));
    this.gameList = gameList || [];
    this.salesId = salesId || 0;
    const containItemSpecification = (o) => {
      const actId = o.actId || o.activityId;
      const item = this.gameList
        .find(t =>
          t.id === actId || t.activityId === actId
        );
      if (!item) {
        return false;
      }
      this.item = item;
      return true;
    };
    this.specification = this.specification.and(new DynamicSpecification(containItemSpecification));
  }
  action () {
    const salesId = this.salesId;
    const item = this.item;
    layerManager.openDealerAct(item.activityId, item.activityType, salesId);
    return true;
  }
}

/**
 * 首屏视频列表弹层
 */
export class HomeVideoList extends HomePoup {
  constructor (queryParams, videoNumInfo) {
    super(queryParams, new VideoListSpecification(videoNumInfo));
  }
  action () {
    layerManager.openVideoList();
  }
}
/**
 * 首屏3d单车弹层
 */
export class HomeThreeCarPoup extends HomePoup {
  constructor (queryParams) {
    super(queryParams, new ThreeCarSpecification());
  }
  action () {
    layerManager.open3dCar({ seriesid: this.queryParams.seriesId });
  }
}
/**
 * 红包弹层
 */
export class RedPacketPoup extends HomePoup {
  constructor (queryParams, dealerId, redPacketInfo, icsShowState) {
    super(queryParams, new RedPacketSpecification(redPacketInfo, dealerId, icsShowState));
    this.redPacketInfo = redPacketInfo;
    this.dealerId = dealerId;
  }
  action () {
    layerManager.openRedPacket({
      propsData: {
        dealerId: this.dealerId,
        seriesId: (this.redPacketInfo && this.redPacketInfo.seriesId) || 0,
        promotionId: this.redPacketInfo.promotionId,
        redPacketsTypeId: this.redPacketInfo.typeId,
      },
    });
  }
}
/**
 * 红包分享提示弹层
 */
export class RedPacketSharedTipPoup extends HomePoup {
  constructor (queryParams, redPacketList, salesId) {
    super(queryParams, new RedPacketSharedTipSpecification(redPacketList));
    this.salesId = salesId || 0;
    this.redPacketList = redPacketList;
    const redPacketListCountIsSatisfied = (o) => {
      let redPacketId = o.promotionId || '';
      redPacketId = encodeURIComponent(redPacketId);
      this.redPacketList = redPacketList.filter(
        item => item.landUrl.indexOf(redPacketId) === -1
      );
      return this.redPacketList.length > 0;
    };
    this.specification = this.specification.and(new DynamicSpecification(redPacketListCountIsSatisfied));
  }
  action () {
    layerManager.openShareRedPacket({
      propsData: { redPacketList: this.redPacketList, salesId: this.salesId }
    });
  }
}
/**
 * 红包分享弹层
 */
export class RedPacketSharedPoup extends HomePoup {
  constructor (queryParams, redPacketList) {
    super(queryParams, new RedPacketSharedSpecification(redPacketList));
    this.redpacketInfo = null;
    this.redPacketList = redPacketList;
    const redPacketListCountIsSatisfied = (o) => {
      const activityId = o.activityId || 0;
      const promotionId = o.promotionId || '';
      let urlRedpacketActivity = [];
      if (activityId > 0) {
        urlRedpacketActivity = this.redPacketList.filter(t => t.activityId === activityId);
      } else if (promotionId) {
        let redpackId = encodeURIComponent(promotionId);
        urlRedpacketActivity = this.redPacketList.filter(t => t.landUrl.indexOf(redpackId) > -1);
      }
      if (urlRedpacketActivity && urlRedpacketActivity.length > 0) {
        this.redpacketInfo = urlRedpacketActivity[0];
        return true;
      }
      return false;
    };
    this.specification = this.specification.and(new DynamicSpecification(redPacketListCountIsSatisfied));
  }
  action () {
    layerManager.open(layerNames.ACTIVITY_REDPACKET, { options: this.redpacketInfo });
  }
}


/**
 * 开屏弹层
 */
export class WelcomeAdPoup extends HomePoup {
  constructor (queryParams, adData, icsShowState) {
    super(queryParams, new WelcomeAdSpecification(icsShowState));
    this.specification = this.specification.and(new DynamicSpecification(() => {
        return adData && adData.imageUrl;
      }));
    this.adData = adData;
  }
  execute () {
    if (this.canExecute()) {
      this.action();
      return false;
    }
    return false;
  }
  action () {
    layerManager.open(layerNames.WELCOME_AD, { adData: this.adData, zIndex: 10000 });
  }
}

/**
 * 开屏松鼠资源位-VR带看引导弹层
 */
export class VRShowTapeGuidePoup extends HomePoup {
  constructor (queryParams, isInWorkTime, hasIm, imInfo) {
    super(queryParams, new VRShowTapeGuideSpecification());
    this.hasIm = hasIm;
    this.imInfo = imInfo;
    this.isInWorkTime = isInWorkTime;
  }
  action () {
    if (!this.isInWorkTime) {
      layerManager.openHomeConfirm({
        propsData: vrConfrimParam(this.hasIm, this.imInfo)
      });
    }
  }
}
